/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  encryptData.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:26
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

let JSEncrypt = function () {
  return {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setPublicKey() {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    encrypt() {},
  };
};
// eslint-disable-next-line @typescript-eslint/no-var-requires
JSEncrypt = require("jsencrypt").JSEncrypt;

// @ts-ignore
const encrypt = new JSEncrypt();
encrypt.setPublicKey(
  "-----BEGIN PUBLIC KEY-----\\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDg3/t1twW8BvmdWXMvDyaKot2L\\neb5BX75mBi6cxkxBDUx5SCnARdWPUkdqpBIBMD6xgkwA3LuWFGWHQl4nou+p2no4\\ndC0wAJB3w9sznvaah3Lf9z3iB9+zis8mT4N57aK7zHBQ4J725MJDtLrepi8MSa7f\\npoDEB5BZpeXSw6a4FQIDAQAB\\n-----END PUBLIC KEY-----".replace(
    /\\n/g,
    "\n"
  )
);

export function encryptData(data: string) {
  return encrypt.encrypt(data);
}
